import { createActionsHook } from "react-redux-actions-hook";
import { ArizonaActionType } from "./constants";

export const setChart = (chart) => {
    return { type: ArizonaActionType.SET_CHART, chart };
};

export default createActionsHook({
    setChart,
});